import { createReducer } from 'typesafe-actions';
import { signInActions, signOutActions } from '~/features/auth/store/actions';
import { createContactActions } from '~/features/dashboard/store/actions';
import { User } from '~/store/user/models';

export class State {
    authorized: boolean = false;
    data: User | null = null;
}

export const reducer = createReducer(new State())
    .handleAction(createContactActions.success, (state, { payload }) => {
        // remove this, when data layer being stable
        if (!state.data) {
            return state;
        }

        const contacts = state.data.contacts || [];

        contacts.push(payload);

        return {
            ...state,
            data: {
                ...state.data,
                contacts,
            },
        };
    })
    .handleAction(signInActions.success, (state, { payload }) => ({
        ...state,
        authorized: true,
        data: payload,
    }))
    .handleAction(signOutActions.success, state => ({
        ...state,
        authorized: false,
        data: null,
    }));
